import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  filters: {
    width: '80%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    gap: '1rem',
  },
  selectField: {
    display: 'flex',
    width: '25rem',
  },
  select: {
    minHeight: '2.2rem',
    maxHeight: '5rem',
    overflow: 'auto',
    scrollbarWidth: 'none',
  },
  numberField: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
}));

export default useStyles;
